import { Controller } from "@hotwired/stimulus"

// Prevents pasting on input fields
// Use on confirmation fields to ensure users manually re-enter values
//
// Usage:
//   <input data-controller="tax-organizer--no-paste" ...>
//
export default class extends Controller {
  connect() {
    this.element.addEventListener('paste', this.preventPaste)
  }

  disconnect() {
    this.element.removeEventListener('paste', this.preventPaste)
  }

  preventPaste = (event) => {
    event.preventDefault()
  }
}
